import React from 'react';
import { CURRENCY_FULL } from '../../../config';
import PropTypes from 'prop-types';
import { useProviderCurrency } from '../../../utilities/hooks/useProviderCurrency';

const CurrencyInput = ({ label, value, setValue }) => {
	// Prices are entered in the provider's own currency (set via Stripe Connect).
	const providerCurrency = useProviderCurrency();

	const getCurrency = () => providerCurrency ?? CURRENCY_FULL;

	return (
		<div style={{ marginTop: '30px' }} className="group-inputs">
			<label style={{ fontSize: '16px' }}>{label}</label>
			<div className="currency-input-container">
				<input
					className="currency-input"
					type="number"
					min="1"
					step="1"
					onKeyDown={(e) =>
						['e', 'E', '+', '-'].includes(e.key) && e.preventDefault()
					}
					value={value}
					onChange={(e) => setValue(e.target.value)}
				/>
				<div className="currency-input-short">{getCurrency().code}</div>
			</div>
		</div>
	);
};

CurrencyInput.propTypes = {
	label: PropTypes.string,
	value: PropTypes.number,
	setValue: PropTypes.func
};

export default CurrencyInput;
